import React, { useEffect, useMemo, useState } from 'react'
import TransaksiService from '../services/transaksi/TransaksiService'

const GetDokumen = ({nomorAju, idJnsDok}) => {
    let transaksiService = useMemo(() => new TransaksiService(), [])
    const [nomorDokumen, setNomorDokumen] = useState('')

    useEffect(() => {
        const getNomorDokumen = async () => {
            const response = await transaksiService.getPpmDokByAjuKodeDok(nomorAju, idJnsDok)
            setNomorDokumen(response.data.nomor)
        }
        getNomorDokumen()
    }, [transaksiService, nomorAju, idJnsDok])

    return (
        <>
            {nomorDokumen}
        </>
    )

}

export default GetDokumen